import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { EditIconPencil, PlusIcon, TrashIcon } from '../../../Assets/icons';
import useProfile from '../../../Features/useProfile';
import AlertModal from '../../../Modals/AlertModal';
import DefineTimeAlertModal from '../../../Modals/DefineTimeModal';
import Button from '../../UI/Button';
import NoDataFound from '../NoDataFound';
import SlotLabel from './SlotLabel';
import classes from './TimeTable.module.css';

const TimeTable = () => {
  const {
    deleteDoctorTime,
    addDoctorTime,
    doctorTimes: times,
    updateDoctorTime,
    getDoctorTime,
    loading
  } = useProfile();
  const [showDeleteTime, setShowDeleteTime] = useState(false);
  const [showDefineTimeAlertModal, setShowDefineTimeAlertModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const makeSchedule = [];
  const doctorTimes = times?.[0]?.doctorTimes;

  // Process doctor times into a consistent format
  doctorTimes?.forEach((doctorTimeSlot) => {
    doctorTimeSlot?.data?.forEach((doctorSlot) => {
      makeSchedule.push({
        day: doctorSlot?.day,
        doctorClinicId: doctorSlot?.doctorClinicId,
        doctorTimeId: doctorSlot?.doctorTimeId,
        isActive: doctorSlot?.isActive,
        slot: `${doctorSlot?.timeFrom} - ${doctorSlot?.timeTo}`,
        timezone: 'Asia/Karachi'
      });
    });
  });

  // Group slots by day
  const groupByDay = (schedules) => {
    return schedules.reduce((acc, schedule) => {
      const { day, ...rest } = schedule;
      if (!acc[day]) {
        acc[day] = [];
      }
      acc[day].push({ day: day, ...rest });
      return acc;
    }, {});
  };

  const groupedSlots = groupByDay(makeSchedule);

  // Find the maximum number of slots in any day
  const findMaxLengthGroup = Object.values(groupedSlots).reduce(
    (max, slots) => Math.max(max, slots?.length || 0),
    0
  );
  const movingArray = new Array(findMaxLengthGroup).fill(0);
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  useEffect(() => {
    getDoctorTime();
  }, []);

  // Helper function to get slots for a specific day and index
  const getSlotForDay = (day, index) => {
    const daySlots = groupedSlots[day] || [];
    return daySlots[index] || null;
  };

  return (
    <>
      <style jsx>{`
        .table-wrapper {
          height: 100%;
          overflow: scroll;
        }
      `}</style>
      <div className={classes.wrapper}>
        <div className={classes['clinic-header']}>
          <h2>Clinic Time</h2>
          <div className={classes['header-buttons']}>
            <Button
              onClick={() => {
                setSelectedItem(null);
                setShowDefineTimeAlertModal(true);
              }}
              className={classes['header-action']}
              leftIcon={<PlusIcon size={15} color="#ffff" />}
              label="Add"
            />
            <Button
              onClick={() => setShowDefineTimeAlertModal(true)}
              leftIcon={<EditIconPencil size={15} color="#ffff" />}
              label="Edit"
              disabled={!selectedItem}
            />
            <Button
              onClick={() => setShowDeleteTime(true)}
              className={classes.deleteBtn}
              leftIcon={<TrashIcon size={15} color="#ffff" />}
              label="Delete"
              disabled={!selectedItem}
            />
          </div>
        </div>
        <div className={clsx(classes.tableContainer, 'table-wrapper scrollbar1')}>
          <table>
            <thead>
              <tr>
                {days.map((day) => (
                  <th key={day} style={{ width: '14.28%', textAlign: 'center' }}>
                    {day}
                  </th>
                ))}
              </tr>
            </thead>
            {movingArray.length > 0 ? (
              <tbody>
                {movingArray.map((_, rowIndex) => (
                  <tr key={rowIndex} className={classes.row}>
                    {days.map((day) => {
                      const slot = getSlotForDay(day, rowIndex);
                      return (
                        <td key={`${day}-${rowIndex}`} style={{ width: '14.28%' }}>
                          {slot && (
                            <SlotLabel
                              className={clsx({
                                [classes.shine]: slot.doctorTimeId === selectedItem?.doctorTimeId
                              })}
                              label={slot.slot}
                              onClick={() => setSelectedItem(slot)}
                            />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={7}>
                    <NoDataFound />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>

      {showDeleteTime && (
        <AlertModal
          loading={loading}
          show={showDeleteTime}
          setShow={setShowDeleteTime}
          title="Delete Time"
          content="Are you sure want to delete"
          onConfirm={() => {
            deleteDoctorTime({ doctorTimeId: selectedItem?.doctorTimeId }, () => {
              setShowDeleteTime(false);
              setSelectedItem(null);
            });
          }}
        />
      )}
      {showDefineTimeAlertModal && (
        <DefineTimeAlertModal
          loading={loading}
          show={showDefineTimeAlertModal}
          setShow={setShowDefineTimeAlertModal}
          onSubmit={selectedItem ? updateDoctorTime : addDoctorTime}
          data={selectedItem}
        />
      )}
    </>
  );
};

export default TimeTable;
